'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var useOnClickOutside = function (handler, refArray, ignoreClickOnClasses, checkItemClass) {
    React.useEffect(function () {
        var listener = function (event) {
            var isClickedOnElement = false;
            var isClickedOnRef = refArray.some(function (elementRef) {
                var _a, _b, _c, _d, _e, _f;
                var eventTargetHasClass = checkItemClass ? (_a = event.target.className) === null || _a === void 0 ? void 0 : _a.includes('item-') : false;
                if (checkItemClass && eventTargetHasClass) {
                    var classToCheck = (_b = event.target.className.split(' ')
                        .find(function (cl) { return cl.includes('item-'); })) !== null && _b !== void 0 ? _b : '';
                    var elementToCheck = (_c = elementRef.current) === null || _c === void 0 ? void 0 : _c.getElementsByClassName(classToCheck)[0];
                    return elementToCheck ? (_d = elementRef.current) === null || _d === void 0 ? void 0 : _d.contains(elementToCheck) : true;
                }
                return (_f = (_e = elementRef.current) === null || _e === void 0 ? void 0 : _e.contains(event.target)) !== null && _f !== void 0 ? _f : true;
            });
            if (ignoreClickOnClasses && ignoreClickOnClasses.length > 0) {
                var ignoreElements = ignoreClickOnClasses.map(function (ignoreClass) { return Array
                    .from(document.getElementsByClassName(ignoreClass)); }).flat();
                isClickedOnElement = ignoreElements.some(function (element) { var _a; return (_a = element.contains(event.target)) !== null && _a !== void 0 ? _a : true; });
            }
            if (!isClickedOnRef && !isClickedOnElement) {
                handler(event);
            }
        };
        document.addEventListener('click', listener);
        return function () {
            document.removeEventListener('click', listener);
        };
    }, [refArray, handler, ignoreClickOnClasses, checkItemClass]);
};

exports.useOnClickOutside = useOnClickOutside;
